/* Alpacas Foods — máscaras de formulário BR. Porta lib/br.ts.
   Aplica em inputs com data-mask="cnpj|cpf|phone|cep". */
(function () {
  'use strict';
  function digits(v) { return v.replace(/\D/g, ''); }

  var masks = {
    cnpj: function (v) {
      return digits(v).slice(0, 14)
        .replace(/^(\d{2})(\d)/, '$1.$2')
        .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
        .replace(/\.(\d{3})(\d)/, '.$1/$2')
        .replace(/(\d{4})(\d)/, '$1-$2');
    },
    cpf: function (v) {
      return digits(v).slice(0, 11)
        .replace(/^(\d{3})(\d)/, '$1.$2')
        .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
        .replace(/\.(\d{3})(\d)/, '.$1-$2');
    },
    phone: function (v) {
      var d = digits(v).slice(0, 11);
      if (d.length <= 10) return d.replace(/^(\d{2})(\d)/, '($1) $2').replace(/(\d{4})(\d)/, '$1-$2');
      return d.replace(/^(\d{2})(\d)/, '($1) $2').replace(/(\d{5})(\d)/, '$1-$2');
    },
    cep: function (v) { return digits(v).slice(0, 8).replace(/^(\d{5})(\d)/, '$1-$2'); }
  };

  document.addEventListener('input', function (e) {
    var el = e.target;
    var kind = el.getAttribute && el.getAttribute('data-mask');
    if (kind && masks[kind]) el.value = masks[kind](el.value);
  });
})();
